export type PostalCode = {
  value: number;
  title: string;
};

export const greenlandPostalCodes: PostalCode[] = [
  { value: 3900, title: "3900 Nuuk (Godthåb)" },
  { value: 3905, title: "3905 Nuussuaq (Bydel i Nuuk)" },
  { value: 3910, title: "3910 Kangerlussuaq (Søndre Strømfjord)" },
  { value: 3911, title: "3911 Sisimiut (Holsteinsborg)" },
  { value: 3912, title: "3912 Maniitsoq (Sukkertoppen)" },
  { value: 3913, title: "3913 Tasiilaq (Angmagsalik)" },
  { value: 3915, title: "3915 Kulusuk" },
  { value: 3919, title: "3919 Alluitsup Paa" },
  { value: 3920, title: "3920 Qaqortoq (Julianehåb)" },
  { value: 3921, title: "3921 Narsaq" },
  { value: 3922, title: "3922 Nanortalik" },
  { value: 3923, title: "3923 Narsarsuaq" },
  { value: 3924, title: "3924 Ikerasassuaq (Prins Christian Sund)" },
  { value: 3930, title: "3930 Kangilinnguit (Grønnedal)" },
  { value: 3932, title: "3932 Arsuk" },
  { value: 3940, title: "3940 Paamiut (Frederikshåb)" },
  { value: 3950, title: "3950 Aasiaat (Egedesminde)" },
  { value: 3951, title: "3951 Qasigiannguit (Christianshåb)" },
  { value: 3952, title: "3952 Ilulissat (Jakobshavn)" },
  { value: 3953, title: "3953 Qeqertarsuaq (Godhavn)" },
  { value: 3955, title: "3955 Kangaatsiaq" },
  { value: 3961, title: "3961 Uummannaq" },
  { value: 3962, title: "3962 Upernavik" },
  { value: 3964, title: "3964 Qaarsut" },
  { value: 3970, title: "3970 Pituffik/Dundas (Thule Air Base)" },
  { value: 3971, title: "3971 Qaanaaq (Thule)" },
  { value: 3972, title: "3972 Station Nord" },
  { value: 3980, title: "3980 Ittoqqortoormiit (Scoresbysund)" },
  { value: 3982, title: "3982 Mestersvig" },
  { value: 3984, title: "3984 Danmarkshavn" },
  { value: 3985, title: "3985 Constable Pynt" },
  { value: 3992, title: "3992 Slædepatruljen SIRIUS" },
] as const;
